var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidgetNewOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 105,
    viewBox: "0 0 85 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7781 -1.69995L55.4287 17.9265C55.4287 17.9265 74.2552 33.7786 75.9781 35.2884C81.147 39.8176 84.5929 44.5355 84.5929 48.4608V-1.69995H32.7781Z",
    fill: "#00FF3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7254 69.2572C65.8927 70.7292 56.4794 70.4272 49.5876 70.4272C47.8646 70.4272 12.9012 70.3517 12.9012 70.3517C5.75721 70.3517 0 75.1829 0 81.5992V105H84.5931V79.3346V70.0121V48.4607C84.5931 57.0661 82.4919 65.6339 70.7254 69.2572Z",
    fill: "#00FF3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetNewOrder);
export default __webpack_public_path__ + "static/media/widget-new-order.70f365f4237e2d28df3c1278d7433f64.svg";
export { ForwardRef as ReactComponent };